"use client";

import { FormatFilterControl } from "@/components/format-filter-control";
import type { LinkTarget } from "@/components/link";
import type { FilterOption } from "@/components/ui/filter-select";
import type { FacetFiltersController } from "@/facets/use-facet-filters";

interface FacetFormatControlProps {
  className?: string;
  formatAvailable: boolean;
  formatOptions: FilterOption[];
  controller: FacetFiltersController;
  formatValue?: string;
  onFormatChange?: (value: string) => void;
  formatTotalCount?: number;
  formatLinkTarget?: (value: string) => LinkTarget;
}

/** Format chip row bound to the facet controller (or to an explicit value/handler). */
export function FacetFormatControl({
  className,
  formatAvailable,
  formatOptions,
  controller,
  formatValue,
  onFormatChange,
  formatTotalCount,
  formatLinkTarget,
}: FacetFormatControlProps) {
  if (!formatAvailable) return <span />;

  const formatOptionValues = formatOptions.map((opt) => opt.value);
  const formatTotal =
    formatTotalCount ?? formatOptions.reduce((sum, opt) => sum + (opt.count ?? 0), 0);
  const selectedFormat =
    formatValue ?? controller.getValues("format", formatOptionValues)[0] ?? "all";

  return (
    <FormatFilterControl
      className={className}
      options={formatOptions}
      value={selectedFormat}
      all={{ count: formatTotal }}
      linkTarget={formatLinkTarget}
      onChange={(nextFormat) => {
        if (onFormatChange) {
          onFormatChange(nextFormat);
          return;
        }
        controller.setValues(
          "format",
          nextFormat === "all" ? [] : [nextFormat],
          formatOptionValues,
        );
      }}
    />
  );
}
